import { Casts, Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Moment } from 'moment';
import { Entity } from './Entity';
import { Company } from './Company';
import { Team, } from './Team';
import { Contact } from './Contact';
import { BudgetStore } from './Budget';

export const CONTRACT_STATUS_QUOTATION_DRAFT = 'quotation draft'
export const CONTRACT_STATUS_QUOTATION_SENT = 'quotation sent'
export const CONTRACT_STATUS_ON_HOLD = 'quotation on hold';
export const CONTRACT_STATUS_QUOTATION_REJECTED = 'quotation rejected'
export const CONTRACT_ACTIVE = 'contract active'
export const CONTRACT_FINISHED = 'contract finished'

export const CONTRACT_STATUSES = [
    CONTRACT_STATUS_QUOTATION_DRAFT,
    CONTRACT_STATUS_QUOTATION_SENT,
    CONTRACT_STATUS_ON_HOLD,
    CONTRACT_STATUS_QUOTATION_REJECTED,
    CONTRACT_ACTIVE,
    CONTRACT_FINISHED,
] as const

export const CONTRACT_TYPE_SOW = 'sow'
export const CONTRACT_TYPE_FIXED_PRICE = 'fixed price'
export const CONTRACT_TYPE_SLA = 'sla'

export const CONTRACT_TYPES = [
    CONTRACT_TYPE_SOW,
    CONTRACT_TYPE_FIXED_PRICE,
    CONTRACT_TYPE_SLA,
] as const

export const INVOICE_FREQUENCY_MONTHLY = 'monthly'
export const INVOICE_FREQUENCY_QUARTERLY = 'quarterly'
export const INVOICE_FREQUENCY_PER_DELIVERY = 'per delivery'
export const INVOICE_FREQUENCY_ONCE = 'once'

export const INVOICE_FREQUENCIES = [
    INVOICE_FREQUENCY_MONTHLY,
    INVOICE_FREQUENCY_QUARTERLY,
    INVOICE_FREQUENCY_PER_DELIVERY,
    INVOICE_FREQUENCY_ONCE,
] as const


export class Contract extends Model {
    static backendResourceName = 'contract';

    static fileFields = [
        'signed_pdf'
    ]
    @observable id = null;
    @observable title = ''
    @observable entity = this.relation(Entity);
    @observable company = this.relation(Company);
    @observable reference = ''
    @observable description = ''
    @observable quotationLink = ''
    @observable signedPdf =  null;

    @observable team = this.relation(Team);
    @observable customerContact = this.relation(Contact);
    @observable projectLead = this.relation(Contact);
    @observable devLead = this.relation(Contact);
    @observable uxdLead = this.relation(Contact);

    @observable status: string = 'quotation draft' as const

    @observable type: string | null = null;
    @observable startDate: null | Moment = null;
    @observable endDate: null | Moment = null;
    @observable invoiceFrequency: string | null = null;
    @observable paymentDays: number | null = null;

    @observable budgets = this.relation(BudgetStore)

    casts() {
        return {
            startDate: Casts.date,
            endDate: Casts.date,
        };
    }
}

export class ContractStore extends Store {
    Model = Contract;
    static backendResourceName = 'contract';
}
